import { NavigationMenu } from '../../../navigationDrawer/navigationDrawer';

export const userMenu = (logoutCallback: () => void): NavigationMenu => ({
  items: [
    {
      title: 'routes.userProfile',
      icon: 'mdi-badge-account-horizontal-outline',
      path: '/profile'
    },
    {
      title: 'app.logout',
      icon: 'mdi-logout',
      callback: logoutCallback
    }
  ],
  title: 'app.userMenu',
  icon: 'mdi-account'
});
